import { Link } from "react-router-dom";
import type { Video } from "@/data/videos";
import { formatPlayCount, getCategoryName } from "@/data/videos";

interface VideoCardProps {
  video: Video;
  showCategory?: boolean;
}

export default function VideoCard({ video, showCategory = false }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group block cursor-pointer overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-colors duration-300 hover:border-primary-300"
    >
      <div className="relative aspect-video w-full overflow-hidden bg-background-200">
        <img
          src={video.cover}
          alt={video.title}
          title={`${video.title} 免费在线观看`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-70"></div>
        <span className="absolute bottom-2 right-2 rounded-md bg-foreground-950/80 px-2 py-0.5 text-xs font-label text-background-50">
          {video.duration}
        </span>
        {showCategory && (
          <span className="absolute left-2 top-2 rounded-md bg-primary-500/90 px-2 py-0.5 text-xs font-label text-background-50">
            {getCategoryName(video.categoryId)}
          </span>
        )}
      </div>
      <div className="p-3">
        <h3 className="line-clamp-1 text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
          {video.title}
        </h3>
        <p className="mt-1 line-clamp-1 text-xs text-foreground-500">
          {video.year} · {video.region} · {video.type}
        </p>
        <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {formatPlayCount(video.playCount)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500"></i>
            {video.rating}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {video.uploadedAt}
          </span>
        </div>
      </div>
    </Link>
  );
}